'use client'
import styles from './FixedBackground.module.scss'
import { useScrollHandler } from '@/hooks/scrollHandler'
import { useCallback, useState } from 'react'

export const FixedBackground = () => {
  const [angle, setAngle] = useState(0)

  const bgRotate = useCallback(() => {
    setAngle(window.scrollY / 10)
  }, [])

  useScrollHandler(bgRotate)

  return (
    <div
      className={styles.container}
      // @ts-ignore
      style={{ '--fixed-bg-rotate': `${angle}deg` }}
    >
      <div className={styles.circleBg}>
        <div className={styles.circle}></div>
      </div>
    </div>
  )
}
